import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { formatRelativeTime } from "../utils/dateUtils";
import NewCircuitModal from "../components/NewCircuitModal";
import Pagination from "./Pagination";


const CircuitList = ({ circuits, onDelete}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [viewMode, setViewMode] = useState('card'); // 'list' or 'card'
  const navigate = useNavigate();
  const itemsPerPage = 6;


  const totalPages = Math.ceil(circuits.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentCircuits = circuits.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const toggleViewMode = () => {
    setViewMode(viewMode === 'list' ? 'card' : 'list');
  };



  return (
    <>
      {circuits.length === 0 ? (
        <div className="columns is-vcentered" style={{ height: "100%", width: "100%", textAlign: "center" }}>
          <div className="column">
            <p className="is-size-2 has-text-weight-light is-unselectable">You have no circuits</p>
            <button
              onClick={() => setCreateModalOpen(true)}
              className="button is-medium is-link"
            >
              <span className="icon">
                <i className="fas fa-plus"></i>
              </span>
              <span>New Circuit</span>
            </button>
          </div>
        </div>
      ) : (
        <>
          <div className="level">
            <div className="level-left"></div>
            <div className="level-right">
              <button
                className="button is-link mr-2"
                onClick={() => setCreateModalOpen(true)}
              >
                <span className="icon">
                  <i className="fas fa-plus"></i>
                </span>
                <span>New Circuit</span>
              </button>
              <button
                className="button is-outlined is-dark"
                onClick={toggleViewMode}
              >
                <span className="icon">
                  {viewMode === 'list' ? (
                    <i className="fas fa-th-large"></i>
                  ) : (
                    <i className="fas fa-list"></i>
                  )}
                </span>
                <span>{viewMode === 'list' ? 'Card View' : 'List View'}</span>
              </button>
            </div>
          </div>

          <div className="content" style={{ height: "600px" }}>
            {viewMode === 'list' ? (
              <div className="box">
                <table className="table is-fullwidth circuits-table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Name</th>
                      <th>Framework</th>
                      <th>Last Updated</th>
                      <th>Snapshots</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentCircuits.map((circuit, index) => (
                      <tr key={circuit.id}>
                        <td>{index + 1}.</td>
                        <td>{circuit.name}</td>
                        <td>{circuit.frameworks.name + ' ' + circuit.frameworks?.version}</td>
                        <td>{formatRelativeTime(circuit.updated_at)}</td>
                        <td>{circuit?.snapshot?.length || 'None'}</td>
                        <td>
                          <a href={`/circuits/${circuit.id}`} className="button is-primary">
                            <span className="icon">
                              <i className="fas fa-pencil-alt"></i>
                            </span>
                            <span>Open editor</span>
                          </a>
                          <a className="button is-dark ml-2" onClick={() => onDelete(circuit.id)}>
                            <span className="icon">
                              <i className="fas fa-trash"></i>
                            </span>
                            <span>Delete circuit</span>
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="fixed-grid  has-1-cols has-2-cols-tablet has-3-cols-desktop">
                <div className="grid is-gap-4">
                  {currentCircuits.map((circuit) => (
                    <div key={circuit.id} className="cell">
                      <div className="card is-unselectable card-hover">
                        <div className="card-content">
                          <div className="content">
                            <div className="level is-mobile mb-1">
                              <div className="level-left">
                                <div className="level-item">
                                  <h1 className="title has-text-weight-semibold mb-2">
                                    {circuit.name}
                                  </h1>
                                </div>
                              </div>
                              <div className="level-right">
                                <div className="level-item">
                                  <span className="tag">
                                    {circuit.frameworks.name + ' ' + circuit.frameworks?.version}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="level is-mobile mb-1">
                              <div className="level-left">
                                <div className="level-item">
                                  <span className="icon is-small">
                                    <i className="fas fa-camera"></i>
                                  </span>
                                </div>
                                <div className="level-item">
                                  <span>Snapshots: {circuit.snapshot?.length || 'None'}</span>
                                </div>
                              </div>
                            </div>
                            <div className="level is-mobile mb-1">
                              <div className="level-left">
                                <div className="level-item">
                                  <span className="icon is-small">
                                    <i className="far fa-calendar"></i>
                                  </span>
                                </div>
                                <div className="level-item">
                                  <span>Last updated {formatRelativeTime(circuit.updated_at)}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <footer className="card-footer">
                          <button className="card-footer-item button is-primary is-medium is-radiusless px-0" onClick={() => { navigate(`/circuits/${circuit.id}`); }}>
                              Open editor
                              <span className="icon ml-6">
                                <i className="fas fa-arrow-right"></i>
                              </span>
                          </button>
                          <button className="card-footer-item button is-dark is-radiusless px-0" onClick={() => onDelete(circuit.id)}>
                              Delete Circuit
                              <span className="icon ml-2">
                                <i className="fas fa-trash"></i>
                              </span>
                          </button>
                        </footer>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </>
      )
      }
      <NewCircuitModal
        isOpen={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSuccess={(newCircuit) => {
          navigate(`/circuits/${newCircuit.id}`);
        }}
      />
    </>
  );
};

export default CircuitList;